module.exports = __webpack_public_path__ + "img/02.1d53d602.jpg";